export const dashboard = {
    selectedMeter: 'Selected meter:',
    analyticsLabel: 'Analytics',
    period: 'Period:',
    refreshPeriod: 'Refresh:',
    every1secs: 'Every 1 second',
    every2secs: 'Every 2 seconds',
    every5secs: 'Every 5 seconds',
    every10secs: 'Every 10 seconds',
    every30secs: 'Every 30 seconds',
    every60secs: 'Every 60 seconds',
    liveLoading: 'Live data monitoring',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    pvEfficiency: 'PV Efficiency',
    pvOwnUsage: 'PV own power usage',
    pvProduced: 'Produced/Used',
    pvSold: 'Produced/Sold',
    pvUsed: 'Used',
    pvBought: 'Bought',
    cloudSubscription: 'Subscription',
    until: 'Until',
    switchData: 'Switch',
    noData: 'NO DATA',
    wrongTime: 'Your computer time is not correct',
    secondGraph: '2nd graph',
    premiumData: 'Premium data',
    premiumVoltage: 'Voltage',
    premiumApparentPower: 'Apparent power',
    premiumCurrent: 'Current',
    premiumCosPhi: 'CosPhi',
    downloadSvg: 'Download CSV',
    downloadExcel: 'Download Excel',
    onePerSecond: 'One sample per second',
    onePerMinute: 'One sample per minute',
    onePer15Minutes: 'One sample per 15 minutes',
    onePerHour: 'One sample per hour',
    resolution: 'Resolution',
    kwhCost: 'cost pro kilowatt',
    wattUnit: 'watt',
    kwUnit: 'kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'kwh',
    kgUnit: 'Kilogram',
    costUnit: '€',
    batteryCharge: 'battery charge status',
    autonomy: 'autonomy',
    grid: 'Grid',
    production: 'Production',
    battery: 'Battery',
    usage: 'Usage',
    otherDevices: 'Other devices',
    chartModeDevice: 'Devices',
    chartModePhases: 'Default',
    E3DC: 'E3DC',
    EnphaseIqEnvoy: 'Enphase IQ Envoy',
    Fenecon: 'FENECON',
    froniusSolarapiV1: 'Fronius Solar Api V1',
    froniusGen24Modbus: 'Fronius Gen24 Modbus TCP/IP',
    kostalPiko: 'Kostal Piko',
    kostalPlenticore: 'Kostal Plenticore',
    kostalSem: 'Kostal Sem',
    kostalSemInverter: 'Kostal Sem Inverter',
    SIEMENS_SENTRON_PAC_FAMILY: 'Siemens Sentron PAC',
    SENEChome: 'SENEC.Home',
    Shelly1PmPv: 'Shelly 1PM PV',
    HuaweiSun2000dongle: 'Huawai Sun 2000 dongle',
    HuaweiDongleSensor: 'Huawai Sun 2000 dongle & sensor',
    MTecEbGen2TCP: 'M-TEC Energy Butler GEN2',
    MTecEbGen3TCP: 'M-TEC Energy Butler GEN3',
    Phoenix: 'Phoenix',
    RctPower: 'RCT Power',
    SmaDataManager: 'SMA Data Manager',
    SmaEnergyMeter: 'SMA Energy Meter',
    SmaHomeManager: 'SMA Home Manager',
    SmaHybrid: 'SMA Hybrid',
    SmaInverter: 'SMA Inverter',
    Solarwatt: 'Solarwatt',
    SolarEdgeHybrid: 'Solar Edge Hybrid',
    SolarEdgeInverter: 'Solar Edge Inverter',
    Solax: 'Solax',
    SolaxCloudApi: 'Solax Cloud',
    Sonnenbatterie: 'sonnenBatterie',
    Sungrow: 'Sungrow',
    SungrowHybrid: 'Sungrow Hybrid',
    Victron: 'Victron Energy',
    xelectrix: 'xelectrix',
    excelFromP1: 'First period start:',
    excelFromP2: 'Second period start:',
    excelToP1: 'First period end:',
    excelToP2: 'Second period end:',
    uploadLoadprofile: 'Upload Loadprofile',
    uploading: 'uploading',
    uploadStarted: 'file upload started successfully, duration about 5 minutes',
    uploadFailed: 'file upload failed',
    noDataEnergyFlow: 'No data sent by this watt-meter at this time.',
    noDataEnergyFlowHelp: 'Need help? Based on the color of status LED please do the following:',
    noDataEnergyFlowLedGrey: 'connect watt-meter to power',
    noDataEnergyFlowLedBlue1: 'check if your Wi-Fi is up and working',
    noDataEnergyFlowLedBlue2: 'if you changed your Wi-Fi, you have to update the watt-meter Wi-Fi settings',
    noDataEnergyFlowLedGreen: 'contact us at: support@watt-analytics.com',
};
